export default __webpack_public_path__ + "static/media/lewc_logo.018e2f8e.png";